/**
 * MarkdownThemeScope
 * Wraps @uiw/react-md-editor (editor or MDEditor.Markdown) so the library's own light/dark
 * styles follow the landlord theme: it sets `data-color-mode` from the resolved theme.
 * The single shared wrapper; do not hand-write data-color-mode in feature files.
 * `paper` pins light mode for editors placed on a paper surface (.lease-document), which stays
 * light in both themes.
 */

import type { HTMLAttributes } from 'react';
import { useTheme } from '@/contexts/theme.context';

export function MarkdownThemeScope({
  children,
  paper = false,
  ...rest
}: HTMLAttributes<HTMLDivElement> & { paper?: boolean }) {
  const { resolved } = useTheme();
  return (
    <div {...rest} data-color-mode={paper ? 'light' : resolved}>
      {children}
    </div>
  );
}
